import React from "react";

function Nav() {
  return (
    <nav className="nav__bar">
      <div className="nav__flex">
        <div>
          <p className="logo__nav">To-Do</p>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
